import { render, staticRenderFns } from "./TkTab.vue?vue&type=template&id=d9abaa40&"
import script from "./TkTab.vue?vue&type=script&lang=js&"
export * from "./TkTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports